function calculateQuotation(object = {}) {
    const parseNum = (val) => parseFloat(val) || 0;
    const formatNum = (val) => parseNum(val).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
        const floorArea = parseNum(object.floor_area)
        const balcony = parseNum(object.balcony)
        const grossUnitPrice = parseNum(object.gross_unit_price)
        const unitTypeDiscountPct = parseNum(object.unit_type_discount)
        const unitTypeDiscount = parseNum(object.unit_type_discount)
        const launchDiscountPct = parseNum(object.launch_discount)
        const equityPct = parseNum(object.equity)
        const reservationFee = parseNum(object.reservation_fee)
        const monthlyAmortizationInput = parseNum(object.monthly_amortization)
        const retentionPct = parseNum(object.retention)
        const closingFeePct = parseNum(object.closing_fee)

        const grossFloorArea = floorArea + balcony
        const netOfUnitTypeDiscount = grossUnitPrice * (1 - unitTypeDiscountPct / 100)
        const launchDiscountValue = netOfUnitTypeDiscount * (launchDiscountPct / 100)
        const totalContractPrice = netOfUnitTypeDiscount - launchDiscountValue
        const pricePerSQM = totalContractPrice / grossFloorArea
        const equityValue = totalContractPrice * (equityPct / 100)
        const totalEquityNetofRF = equityValue - reservationFee
        const monthlyAmortization = totalEquityNetofRF / (monthlyAmortizationInput || 1)
        const retentionValue = totalContractPrice * (retentionPct / 100)
        const closingFeeValue = totalContractPrice * (closingFeePct / 100)

        return {
            floorArea,
            balcony,
            grossUnitPrice,
            unitTypeDiscount,
            parseNum,
            formatNum,
            grossFloorArea,
            netOfUnitTypeDiscount,
            launchDiscountValue,
            totalContractPrice,
            pricePerSQM,
            equityValue,
            reservationFee,
            totalEquityNetofRF,
            monthlyAmortization,
            retentionValue,
            closingFeeValue
        }
    }

export default calculateQuotation